import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export enum Dashboard {
  admin = 'admin',
  placement_student = 'placement_student',
  classroom_student = 'classroom_student',
}

@Injectable()
export class DashboardService  {
  constructor() { }
  private paramSource = new BehaviorSubject(Dashboard.admin);
  sharedData: Observable<string> = this.paramSource.asObservable();
  setParam(param:Dashboard) { this.paramSource.next(param)}
}
